enum VIDEO_TUTORIAL_STATUS {
  IDLE = 'idle',
  PLAYING = 'playing',
  ENDED = 'ended',
  ERROR = 'error',
}

export default VIDEO_TUTORIAL_STATUS;
